
import React from "react";
import { LineChart, lineElementClasses } from '@mui/x-charts/LineChart';

const labels = {
	t0: "12am",
	t1: "1am",
	t2: "2am",
	t3: "3am",
	t4: "4am",
	t5: "5am",
	t6: "6am",
	t7: "7am",
	t8: "8am",
	t9: "9am",
	t10: "10am",
	t11: "11am",
	t12: "12pm",
	t13: "1pm",
	t14: "2pm",
	t15: "3pm",
	t16: "4pm",
	t17: "5pm",
	t18: "6pm",
	t19: "7pm",
	t20: "8pm",
	t21: "9pm",
	t22: "10pm",
	t23: "11pm",
}

function GTCChart(props: any) {

    const data = props.data || {};

	const keys: string[] = Object.keys(labels);
	const lbls: string[] = Object.values(labels);
	let values = [];
	for (const key of keys) {
		values.push(data[key] || 0);
	}

    return (
        <LineChart
          height={200}
          series={[{ data: values, area: true, showMark: false }]}
          xAxis={[{ scaleType: 'point', data: lbls }]}
          sx={{
            [`& .${lineElementClasses.root}`]: {
              display: 'none',
            },
			'.MuiAreaElement-root': {
				fill: "var(--secondary-color)"
			}
          }}
        />
    );
}

export default GTCChart;